<template>
  <div>
    <modal width="500px" :visible.sync="isShowDialog" :closeOnClickModal="false"  append-to-body>
      <el-form
            ref="form"
            :model="dioForm"
            :rules="rules"
            label-width="100px"
          >
            <!-- 输入key -->
            <el-form-item
              :label="`${$t('public.device')} key`"
              prop="key"
            >
              <el-input
                type="text"
                v-model.trim="dioForm.key"
                :placeholder="$t('public.please_enter')"
              ></el-input>
            </el-form-item>
            <div style="text-align: center;">
              <el-button type="primary"
                @click="handleLoadDevice"
                >{{ $t('public.load') }}
              </el-button>
            </div>
      </el-form>
      <!-- 输入key后的设备列表 -->
      <div v-if="deviceList.length" style="max-height: 400px; overflow: auto;">
        <div  v-for="(item,index) in deviceList" :key="index"
          class="dev-item">
            <div class="bg-theme color-white pd-10">{{item.name}}</div>
            <span class="dev-type-span">{{ deviceTypeConvertFun(item.typeCode) }}</span>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveDevices"
            >{{ $t('public.save') }}
          </el-button>
          <el-button type="primary" @click="isShowDialog = false"
          >{{ $t('public.cancel') }}
        </el-button>
      </div>
    </modal>
    <!-- 注册成功提示 -->
    <modal width="500px" :visible.sync="isShowDialog2" :closeOnClickModal="false" append-to-body>
      <div>{{$t('integration.device_tips')}}</div>
      <div slot="footer" style="display:flex;justify-content: space-between;padding:20px;">
          <span class="under-line pb-5" @click="allClose">
            {{$t('integration.nothing')}}
          </span>
          <span  class="under-line pb-5" @click="handleShowDeviceListDialog">
            {{$t('integration.set_the_devices_now')}}
          </span>
        </div>
    </modal>
  </div>
</template>
<script>
import { deviceTypeConvertFun } from '@/utils/convert';
import { equiIconConvert } from '@/utils/convert';
import { getDevices, saveDevices } from '@/api/modules/device'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      dioForm: {
        key: ''
      },
      deviceList: [],
      deviceTypeConvertFun,
      equiIconConvert,
      isShowDialog2: false
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val)
      }
    },
    rules() {
      return {
        key: [
          { required: true, message: this.$t('integration.cannot_be_empty'), trigger: 'blur' }
        ],
      }
    },
  },
  methods: {
    handleLoadDevice(){
      this.$refs['form'].validate((valid) => {
        if(valid){

          getDevices(this.dioForm.key).then(res => {
            if (res.state.code === 200) {
               this.deviceList = res.result
               if(this.deviceList.length === 0){
                this.$message.error($t('integration.no_device_tips'))
              }
            }
          })

        }
      })
    },
    saveDevices(){
      // 整理数据，符合接口的数据结构
      let params = {
        sensorList: [],
        gatewayList: [],
        displayList: [],
        relayList: [],
        gasList: [],
        magnetismList: []
      }
      this.deviceList.forEach(item => {
        let commonObj = {
          apMacAddr: item.mac,
          no: item.no,
          type: item.type,
          typeCode: item.typeCode
        }
        switch(item.catalog){
          case 0:
            params.sensorList.push({
              tagId: item.name,
              ...commonObj
            })
            break
          case 1:
            params.gatewayList.push({
              name: item.name,
              mac: item.mac,
              no: item.no,
              type: item.type,
              typeCode: item.typeCode
            })

            break
          case 2:
            params.displayList.push({
              displayCode: item.name,
              ...commonObj
            })
            break
          case 3:
            params.relayList.push({
              relayCode: item.name,
              ...commonObj
            })
            break
          case 5:
            params.gasList.push({
              gasCode: item.name,
              ...commonObj
            })
            break
          case 6:
            params.magnetismList.push({
              magnetismCode: item.name,
              ...commonObj
            })
            break
        }
      })
      saveDevices(params).then(({state}) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.isShowDialog2 = true

        }
      })

    },
    allClose(){
      this.isShowDialog2 = false
      this.isShowDialog = false
    },
    handleShowDeviceListDialog(){
      this.isShowDialog2 = false
      this.isShowDialog = false
      this.$emit('nextStep3')
    },
  }
}
</script>
<style lang="scss" scoped>
.under-line{
  color:#344962;
  border-bottom:1px solid #344962;
  cursor: pointer;
}
.dev-item{
  display:flex;
  justify-content: space-between;
  margin:10px;
  .dev-type-span{
    border-bottom:1px solid #344962;
    flex:1;
    text-align: right;
    line-height: 2;
  }
}
</style>
